import z from 'zod'
import { nullSafeFirestoreTimestamp } from '../shared/schema'
import { InstitutionIntegrationType } from './types'

const canvasIntegrationSettingsSchema = z.object({
  canvasClientId: z.string().optional(),
  canvasInstanceHostname: z.string().optional(),
  canvasAuthorizationUrl: z.string().optional(),
  canvasTokenUrl: z.string().optional(),
})

const d2lIntegrationSettingsSchema = z.object({
  ltiClientId: z.string().optional(),
  ltiInstanceHostname: z.string().optional(),
})

// Combined schema that accepts all known settings fields.
// Firestore stores them in a single map, and Zod unions would strip
// unrecognized fields from whichever branch matches first.
const settingsSchema = canvasIntegrationSettingsSchema
  .merge(d2lIntegrationSettingsSchema)
  .partial()

export const schema = z.object({
  integrationType: z.nativeEnum(InstitutionIntegrationType),
  integrationSettings: settingsSchema,
  clientId: z.string().optional(),
  iss: z.string().optional(),
  authenticateUrl: z.string().optional(),
  tokenUrl: z.string().optional(),
  jwksUrl: z.string().optional(),
  updatedAt: nullSafeFirestoreTimestamp(),
})

export const writeSchema = schema.extend({})

export const empty = Object.freeze(
  schema.parse({
    integrationType: InstitutionIntegrationType.canvas,
    integrationSettings: {},
  })
)

export type FirestoreInstitutionIntegration = z.infer<typeof schema>
export type InstitutionIntegrationSettings = z.infer<typeof settingsSchema>
export type InstitutionIntegrationCanvasSettings = z.infer<
  typeof canvasIntegrationSettingsSchema
>
export type InstitutionIntegrationD2LSettings = z.infer<
  typeof d2lIntegrationSettingsSchema
>
